export default __webpack_public_path__ + "static/media/icon-company.886f10eb.svg";